var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolicies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "transactions-icon copy 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "0.0%",
    y: "0.0%",
    width: "100.0%",
    height: "100.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-529.000000, -177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Order-Copy",
    transform: "translate(516.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Growth--Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transactions-icon-copy-7",
    transform: "translate(13.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background-Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style",
    opacity: 0,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#F6931E",
    opacity: 0.159999996,
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "noun-delivery-box-5087203",
    transform: "translate(8.000000, 9.000000)",
    fill: "#F6931E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5763547,5.41933498 L16.8565271,5.41933498 L16.8565271,11.4480296 C16.8565271,11.6351663 16.7552648,11.8081096 16.5916995,11.8997475 C16.4281404,11.9911515 16.2280172,11.9870628 16.0683005,11.8886829 L13.3002586,10.1852346 L10.5322167,11.8884366 C10.3725,11.9868171 10.1726232,11.9904193 10.0088177,11.8995012 C9.84525862,11.8078571 9.74399015,11.6349138 9.74399015,11.4477833 L9.74399015,5.41933498 L0.0241625616,5.41933498 L0.0241625616,24.9575123 L26.5758867,24.9575123 L26.5763547,5.41933498 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3004926,9.06034483 C13.394298,9.06034483 13.4883498,9.08584113 13.5715702,9.13731527 L15.8222475,10.5225369 L15.8222475,5.41915025 L10.7787746,5.41915025 L10.7787746,10.5222906 L13.029452,9.13706897 C13.1126786,9.08607635 13.2067241,9.06033867 13.3005296,9.06033867 L13.3004926,9.06034483 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "26.0320197 4.38485222 22.6333128 0.0423029557 16.0267857 0.0423029557 16.7755542 4.38485222"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "14.976601 0.042364532 11.6240764 0.042364532 10.8750616 4.38491379 15.7256158 4.38491379"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "10.5745074 0.042364532 3.9679803 0.042364532 0.569273399 4.38491379 9.8260468 4.38491379"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicies);
export default __webpack_public_path__ + "static/media/Policies.3243459a3b85ae19ba46378af020d733.svg";
export { ForwardRef as ReactComponent };